import React from 'react';
import styles from './MainContainer.module.sass';

interface MainContainerProps {
  title?: string;
  children: React.ReactNode;
  headerActions?: React.ReactNode;
  fixedHeight?: boolean;
  scrollableContent?: boolean;
}

const MainContainer: React.FC<MainContainerProps> = ({
  title,
  children,
  headerActions,
  fixedHeight = false,
  scrollableContent = false
}) => {
  const containerClass = fixedHeight ? styles.containerFixed :
                        scrollableContent ? styles.containerScrollableContent :
                        styles.containerScrollable;
  const hasActions = headerActions !== undefined && headerActions !== null && headerActions !== false;
  const hasHeader = Boolean(title) || hasActions;

  return (
    <div className={containerClass}>
      {hasHeader && (
        <div className={styles.header}>
          <div>{title}</div>
          <div className={styles.headerActions}>
            {headerActions}
          </div>
        </div>
      )}
      <div className={fixedHeight || scrollableContent ? styles.content : undefined}>
        {children}
      </div>
    </div>
  );
};

export default MainContainer;
